import { render, staticRenderFns } from "./HomeInfoPage.vue?vue&type=template&id=1821937a&scoped=true&"
import script from "./HomeInfoPage.vue?vue&type=script&lang=js&"
export * from "./HomeInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./HomeInfoPage.vue?vue&type=style&index=0&id=1821937a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821937a",
  null
  
)

export default component.exports